import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const DontLeaveRoundInProgressConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.DontLeaveRoundInProgress));
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk="WAIT_UNTIL_ROUND_IS_RESOLVED" />
    </BlockingModalContent>
  );
};
